import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Card, Btn } from "@/components/common";

const ROWS = [["alta", "Adulto alta stagione"], ["bassa_con", "Adulto bassa con escursioni"], ["bassa_senza", "Adulto bassa senza escursioni"], ["b2_4", "Bambino 2-4,99"], ["b5_12", "Bambino 5-12,99"]];
const SC = [["singola_pct", "Supplemento singola %"], ["dieta", "Celiachia / allergie € a persona"], ["natale", "Cena di Natale € adulto"], ["capodanno", "Capodanno € adulto"], ["capodanno_b512", "Capodanno € bimbi 5-12"], ["esc_full", "Escursione Full Day €"], ["esc_half", "Escursione Half Day €"]];
const LINKS = [["google", "Google Reviews"], ["trip", "TripAdvisor"], ["blufb", "Blu Lodge Facebook"], ["bluig", "Blu Lodge Instagram"], ["blusito", "Blu Lodge sito"], ["a20fb", "A20 Facebook"], ["a20ig", "A20 Instagram"], ["a20sito", "A20 sito"], ["pdf_full", "PDF Completo"], ["pdf_flex", "PDF Flessibile"]];
const NOTTI = [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

export default function QuoteSettings({ settings, onSaved }) {
  const [s, setS] = useState(settings);
  const [sel, setSel] = useState(settings.active_id);
  const [pct, setPct] = useState(5);
  const [name, setName] = useState("");
  useEffect(() => { setS(settings); }, [settings]);
  const L = s.listini.find((l) => l.id === sel) || s.listini[0];
  const upd = (fn) => setS({ ...s, listini: s.listini.map((l) => (l.id === L.id ? fn({ ...l }) : l)) });
  const save = async (next = s) => {
    try { await api.put("/quote-settings", next); toast.success("Impostazioni salvate"); onSaved(); } catch (e) { toast.error(formatApiError(e)); }
  };
  const create = async () => {
    try {
      const r = await api.post("/quote-settings/listini", { from_id: L.id, name: name || `${L.name} +${pct}%`, pct: Number(pct) });
      toast.success("Nuovo listino creato"); setSel(r.data.id); setName(""); onSaved();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const inp = "w-full px-1.5 py-1 text-right text-xs rounded border border-slate-300";
  return (
    <div className="space-y-4" data-testid="quote-settings">
      <Card className="p-4">
        <div className="flex flex-wrap items-center gap-2 mb-3">
          <span className="text-sm font-semibold">Listino</span>
          <select data-testid="qs-listino-select" value={L.id} onChange={(e) => setSel(e.target.value)} className="px-2 py-1.5 text-sm rounded border border-slate-300">
            {s.listini.map((l) => <option key={l.id} value={l.id}>{l.name}{l.id === s.active_id ? " (attivo)" : ""}</option>)}
          </select>
          <input data-testid="qs-listino-name" value={L.name} onChange={(e) => upd((l) => ({ ...l, name: e.target.value }))} className="px-2 py-1.5 text-sm rounded border border-slate-300 w-48" />
          {L.id !== s.active_id ? (
            <Btn data-testid="qs-activate" variant="secondary" onClick={() => { const n = { ...s, active_id: L.id }; setS(n); save(n); }}>Rendi attivo</Btn>
          ) : <span className="text-xs font-semibold text-emerald-700">✓ in uso nel preventivatore</span>}
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-xs min-w-[760px]">
            <thead><tr className="text-[10px] uppercase text-slate-500"><th className="text-left py-1">Notti</th>{NOTTI.map((n) => <th key={n} className="text-right">{n}</th>)}</tr></thead>
            <tbody>
              {ROWS.map(([k, lbl]) => (
                <tr key={k}>
                  <td className="py-1 pr-2 font-medium whitespace-nowrap">{lbl}</td>
                  {L[k].map((v, i) => (
                    <td key={i} className="px-0.5"><input data-testid={`qs-${k}-${i}`} type="number" value={v} onChange={(e) => upd((l) => ({ ...l, [k]: l[k].map((x, j) => (j === i ? Number(e.target.value) : x)) }))} className={inp} /></td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-3">
          {SC.map(([k, lbl]) => (
            <label key={k} className="text-[11px] text-slate-500">{lbl}
              <input data-testid={`qs-${k}`} type="number" value={L[k]} onChange={(e) => upd((l) => ({ ...l, [k]: Number(e.target.value) }))} className="block w-full mt-0.5 px-2 py-1 text-sm text-right rounded border border-slate-300" />
            </label>
          ))}
        </div>
        <div className="flex justify-end mt-3"><Btn data-testid="qs-save" onClick={() => save()}>Salva listino</Btn></div>
      </Card>

      <Card className="p-4" data-testid="qs-new-listino">
        <div className="text-sm font-semibold mb-2">Nuovo listino per il prossimo anno</div>
        <div className="flex flex-wrap items-end gap-2">
          <label className="text-[11px] text-slate-500">Parti da<div className="text-sm font-semibold text-slate-800">{L.name}</div></label>
          <label className="text-[11px] text-slate-500">Aumento %<input data-testid="qs-new-pct" type="number" value={pct} onChange={(e) => setPct(e.target.value)} className="block w-20 mt-0.5 px-2 py-1 text-sm text-right rounded border border-slate-300" /></label>
          <label className="text-[11px] text-slate-500">Nome<input data-testid="qs-new-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="es. Listino 2027/28" className="block w-48 mt-0.5 px-2 py-1 text-sm rounded border border-slate-300" /></label>
          <Btn data-testid="qs-new-create" onClick={create}>Crea</Btn>
        </div>
        <p className="text-[11px] text-slate-400 mt-2">I prezzi vengono arrotondati ai 10 €. Poi puoi correggerli uno per uno e renderlo attivo quando vuoi.</p>
      </Card>

      <Card className="p-4" data-testid="qs-links">
        <div className="text-sm font-semibold mb-2">Link nel messaggio</div>
        <div className="grid md:grid-cols-2 gap-2">
          {LINKS.map(([k, lbl]) => (
            <label key={k} className="text-[11px] text-slate-500">{lbl}
              <input data-testid={`qs-link-${k}`} value={s.links[k] || ""} onChange={(e) => setS({ ...s, links: { ...s.links, [k]: e.target.value } })} className="block w-full mt-0.5 px-2 py-1 text-sm rounded border border-slate-300" />
            </label>
          ))}
        </div>
        <div className="flex justify-end mt-3"><Btn data-testid="qs-links-save" onClick={() => save()}>Salva link</Btn></div>
      </Card>
    </div>
  );
}
